import React from "react";

export const CartTitle = ({ item_count }) => {
  const showAccount = false;

  return (
    <div className="title-row px-[20px] py-[16px] items-center">
      <div className="h5 text-black" id="minicart-label">
        Cart ( {item_count} )
      </div>

      <div>
        {showAccount && (
          <a href="/account" className="antialiased [&>svg]:h-[28px]">
            <i className="icon icon-user-bold"></i>
          </a>
        )}

        <div
          className="cursor-pointer"
          x-on:click="$store.global.toggleMinicart()"
        >
          <i className="icon icon-x-thin"></i>
        </div>
      </div>
    </div>
  );
};
